import { Stack, Tab, Tabs, Typography } from '@mui/material';
import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
  useNavigate
} from '@tanstack/react-router';

const Layout = () => {
  const navigate = useNavigate({ from: Route.fullPath });
  const location = useLocation();

  const onSelectLoginTab = () => navigate({ to: '/relationship-health/login' });
  const onSelectParticipantsTab = () =>
    navigate({ to: '/relationship-health/participants' });
  const onSelectPlansTab = () => navigate({ to: '/relationship-health/plans' });

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>Relationship Health</Typography>

      <Tabs
        scrollButtons='auto'
        value={
          location.pathname.startsWith('/relationship-health/login')
            ? 'login'
            : location.pathname.startsWith('/relationship-health/participants')
              ? 'participants'
              : 'plans'
        }
        variant='scrollable'>
        <Tab
          data-testid='tabLoginHealth'
          label='Logins'
          onClick={onSelectLoginTab}
          value='login'
        />
        <Tab
          data-testid='tabParticipants'
          label='Participants'
          onClick={onSelectParticipantsTab}
          value='participants'
        />
        <Tab
          data-testid='tabPlans'
          label='Plans'
          onClick={onSelectPlansTab}
          value='plans'
        />
      </Tabs>

      <Stack sx={{ flex: 1, minHeight: 0 }}>
        <Outlet />
      </Stack>
    </Stack>
  );
};

export const Route = createFileRoute('/relationship-health')({
  beforeLoad: () => {
    if (localStorage.getItem('isAdmin') !== '1') {
      throw redirect({ to: '/organizations' });
    }
  },
  component: Layout
});
